import React from 'react';

import EventRepeatIcon from '@mui/icons-material/EventRepeat';
import {
  Button,
  IconButton,
  Tooltip,
} from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import dayjs from 'dayjs';
import { useDispatch } from 'react-redux';

import { childNotebookSlice } from '@/domain/childNotebook/redux';
import { toStringDate } from '@/utils/date';

import 'dayjs/locale/ja';

dayjs.locale('ja');

/** プロパティ */
export type DateSelectorInput = {
  /** 日 */
  date: string,
}

const DateSelector: React.FC<DateSelectorInput> = ({ date }) => {
  const dispatch = useDispatch();
  const datejs = dayjs(date);
  return (
    <div style={{ display: 'flex' }}>
      <div style={{ margin: '15px' }} />
      <Tooltip title="前日">
        <Button
          onClick={() => {
            const dt = new Date(date);
            dt.setDate(dt.getDate() - 1);
            dispatch(childNotebookSlice.actions.setDate(toStringDate(dt)));
          }}
          variant="outlined"
          color="primary"
        >
          &lt;
        </Button>
      </Tooltip>
      <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
        <DatePicker
          value={datejs}
          label="年月日"
          format="M月D日(dd)"
          views={['year', 'month', 'day']}
          openTo="day"
          slotProps={{
            calendarHeader: { format: 'YYYY年MM月DD日' },
            monthButton: { sx: { fontSize: '0.9em' } },
            textField: { size: 'small', fullWidth: true },
          }}
          slots={{
            toolbar: undefined,
          }}
          onChange={(newDate) => {
            if (newDate) {
              dispatch(childNotebookSlice.actions.setDate(toStringDate(newDate.toDate())));
            }
          }}
        />
      </LocalizationProvider>
      <Tooltip title="翌日">
        <div style={{ display: 'flex' }}>
          <Button
            onClick={() => {
              const dt = new Date(date);
              dt.setDate(dt.getDate() + 1);
              dispatch(childNotebookSlice.actions.setDate(toStringDate(dt)));
            }}
            variant="outlined"
            color="primary"
            disabled={date > toStringDate(new Date())}
          >
            &gt;
          </Button>
        </div>
      </Tooltip>
      <Tooltip title="今日のページに戻る">
        <div>
          <IconButton
            color="primary"
            aria-label="今日のページに戻る"
            onClick={() => {
              const dt = new Date();
              dispatch(childNotebookSlice.actions.setDate(toStringDate(dt)));
            }}
            style={{
              outline: 'solid',
              outlineWidth: 'thin',
              marginLeft: '10px',
            }}
            disabled={date === toStringDate(new Date())}
          >
            <EventRepeatIcon />
          </IconButton>
        </div>
      </Tooltip>
    </div>
  );
};

export default DateSelector;
